(function($) {

	'use strict';

	var init = function() {
		buttonClickHandler();
        registerLink();
	};

	var buttonClickHandler = function() {
		$('.fpForms__action__log').on('click', function(){
			if($('.fpForms__action__log').hasClass('active')) {
                //do nothing
            } else {
                $('.fpForms__action__log').addClass('active');
                $('.fpForms__login').addClass('active');
                $('.fpForms__action__register').removeClass('active');
                $('.fpForms__register').removeClass('active');
            }
		})

        $('.fpForms__action__register').on('click', function(){
			if($('.fpForms__action__register').hasClass('active')) {
                //do nothing
            } else {
                $('.fpForms__action__register').addClass('active');
                $('.fpForms__register').addClass('active');
                $('.fpForms__action__log').removeClass('active')
                $('.fpForms__login').removeClass('active');
            }
		})
	}


    var registerLink = function() {
        
        if($('a').hasClass('forgot-password')) {

            $('.forgot-password').on('click', function(){
                if($('.fpForms__action__register').hasClass('active')) {
                    //do nothing
                } else {
                    $('.fpForms__action__register').addClass('active');
                    $('.fpForms__register').addClass('active');
                    $('.fpForms__action__log').removeClass('active')
                    $('.fpForms__login').removeClass('active');
                }
            })
        }
    }
        
	
	$(document).ready(function() {
		init();
	});

})(jQuery);